import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
// import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import { setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import { ErrorMessages } from "../../../../../../../Constants";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "../../../../../../../Utils/Validation";
import "./index.css";
import DynamicForm from "../../../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../../../Component/DynamicForm/Fields/Select";
import { getOptArr } from "../../../../../../../Utils/arr";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
});

class AddBankDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //   ispayrolllinked: false,
      //   isexpenselinked: false,
      fields: {
        branchname: "",
        accountnumber: "",
        accountholdername: "",
        micrcode: "",
        swiftcode: "",
        ifsccode: "",
        addressline1: "",
        addressline2: "",
      },
      reqFields: {
        // branchname: "",
        // accountnumber: "",
        // accountholdername: "",
        // micrcode: "",
        // swiftcode: "",
        // ifsccode: "",
        // addressline1: "",
        // addressline2: "",
        // ispayrolllinked: false,
        // isexpenselinked: false,
      },
      list: {
        banknameid: "",
        accounttype: "",
        countryid: "",
        stateid: "",
      },
      reqList: {
        // banknameid: "",
        // accounttype: "",
        // countryid: "",
        // stateid: "",
      },
      errors: {},
      helperText: {},
      country: [],
      selectedCountry: {},
      selectedAccount: {},
      selectedState: {},
      selectedbank: {},
      stateprovince: [],
      subscriptionBankList: [],
      accountTypeList: [],
      date: "",
      subscriptionid: null,
    };
  }

  componentWillMount() {
    if (this.props.bank) {
      const { bank } = this.props;

      const fields = {
        branchname: bank.branchname && bank.branchname,
        accountnumber: bank.accountnumber && bank.accountnumber,
        accountholdername: bank.accountholdername && bank.accountholdername,
        // micrcode: bank.micrcode && bank.micrcode,
        // swiftcode: bank.swiftcode && bank.swiftcode,
        ifsccode: bank.ifsccode && bank.ifsccode,
        addressline1: bank.addressline1 && bank.addressline1,
        addressline2: bank.addressline2 && bank.addressline2,
      };

      //   const reqFields = {
      //     branchname: bank.branchname && bank.branchname,
      //     accountnumber: bank.accountnumber && bank.accountnumber,
      //     accountholdername: bank.accountholdername && bank.accountholdername,
      //     ifsccode: bank.ifsccode && bank.ifsccode,
      //     // addressline1: "",
      //     // addressline2: ""

      //     micrcode: bank.micrcode && bank.micrcode,
      //     swiftcode: bank.swiftcode && bank.swiftcode,

      //     addressline1: bank.addressline1 && bank.addressline1,
      //     addressline2: bank.addressline2 && bank.addressline2,
      //     ispayrolllinked: bank.ispayrolllinked && bank.ispayrolllinked,
      //     isexpenselinked: bank.isexpenselinked && bank.isexpenselinked,
      //   };

      const selectedbank = {
        displayname: bank && bank.bankname,
        displayvalue: bank && bank.banknameid,
      };

      const selectedAccount = {
        codeid: bank && bank.accounttype,
        codename: bank && bank.accounttypename,
      };

      //   const reqList = {
      //     banknameid: bank && bank.banknameid,
      //     accounttype: bank && bank.accounttype,
      //   };

      const list = {
        banknameid: bank && bank.banknameid,
        accounttype: bank && bank.accounttype,
        countryid: bank && bank.countryid,
        stateid: bank && bank.stateid,
      };

      this.setState({
        fields,
        selectedbank,
        selectedAccount,
        list,
        ispayrolllinked: bank && bank.ispayrolllinked,
        isexpenselinked: bank && bank.isexpenselinked,
      });
    }

    this.props.ChangeLanguage("configpayroll,navigation");
    this.setState(
      {
        subscriptionid:
          this.props.SubscriptionInfo.SubscriptionData.subscriptionid,
      },
      () => {
        this.GetSubscriptionBankList();
        this.GetAccountTypeList();
        this.GetCountry();
        this.GetStateprovince();
      },
    );
  }

  setHelperText() {
    // this.props.setHelperText({ helperText: this.props.Language ? this.props.Language.configpayroll[HtField] : "" })
  }

  GetSubscriptionBankList() {
    const data = {
      countryid: null,
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post("/superuser/allbankmaster", data)
      .then((result) => {
        const subscriptionBankList = [];
        subscriptionBankList.push(...result.data.result);

        this.setState({ subscriptionBankList }, () => {});
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetAccountTypeList() {
    instance
      .get("superuser/mastercodeid/AccountType")
      .then((result) => {
        const accountTypeList = [];
        accountTypeList.push(...result.data.result);
        this.setState({ accountTypeList });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(...result.data.result);
        this.setState({ country });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetStateprovince(countryid) {
    if (countryid || this.state.list.countryid) {
      const URL = `superuser/statebycountryid/${
        countryid || this.state.list.countryid
      }`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(...result.data.result);
          this.setState({ stateprovince });
        })
        .catch((error) => {
          this.setState({ CommonError: error.message });
        });
    } else {
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince });
    }
  }

  componentDidMount() {}

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    if (field == "accountnumber") {
      if (e.target.value == "") {
        fields[field] = "";
      } else {
        fields[field] = e.target.value.replace(/[^0-9]/g, "");
      }
    } else {
      fields[field] = e.target.value ? e.target.value : "";
    }
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
  }

  ValidateField = async (reqField, type, e) => {
    const { reqFields } = this.state;
    const value = e.target.value ? e.target.value : "";
    if (value && type == "accountnumber") {
      const result = await instance.post("/payroll/uniqueaccountnumber", {
        accountnumber: value,
        subscriptionbankid:
          get(this.props, "bank.subscriptionbankid", "") || null,
      });
      if (!get(result, "data.result[0].isunique", "")) {
        this.props.enqueueSnackbar(ErrorMessages.E1360, { variant: "error" });
        return;
      }
    }
    reqFields[reqField] = value;
    this.setState({ reqFields }, () => {
      if (ValidateAction(this.state, reqField, type)) {
        ValidateReqField(this.state, reqField, type);
        this.forceUpdate();
      }
    });
  };

  OnFormSubmit() {
    this.AddBankDetails();
  }

  Validate() {
    let formIsValid = true;
    const { errors } = this.state;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
      this.setState({ errors });
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
      this.setState({ errors });
    }
    return formIsValid;
  }

  SetPayrolllink() {
    const ispayrolllinked = !this.state.ispayrolllinked;
    this.setState({ ispayrolllinked });
  }

  SetExpenseslink() {
    const isexpenselinked = !this.state.isexpenselinked;
    this.setState({ isexpenselinked });
  }

  AddBankDetails() {
    const data = {
      banknameid: this.state.list.banknameid,
      branchname: this.state.fields.branchname,
      accountholdername: this.state.fields.accountholdername,
      accountnumber: this.state.fields.accountnumber,
      accounttype: this.state.list.accounttype,
      ifsccode: this.state.fields.ifsccode,
      micrcode: this.state.fields.micrcode,
      swiftcode: this.state.fields.swiftcode,
      ispayrolllinked: this.state.ispayrolllinked || false,
      isexpenselinked: this.state.isexpenselinked || false,
      addressline1: this.state.fields.addressline1,
      addressline2: this.state.fields.addressline2,
      countryid: this.state.list.countryid,
      stateid: this.state.list.stateid,
      subscriptionbankid:
        get(this.props, "bank.subscriptionbankid", "") || null,
    };
    const {
      banknameid = null,
      branchname = null,
      accountholdername = null,
      accounttype = null,
      ifsccode = null,
      countryid = null,
      stateid = null,
      addressline1 = null,
    } = data;

    if (
      !(
        banknameid &&
        branchname &&
        accountholdername &&
        accounttype &&
        ifsccode &&
        countryid &&
        stateid &&
        addressline1
      )
    ) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      this.setState({ CommonError: "" });

      const URL = "payroll/insertupdatesubscriptionbank";
      instance
        .post(URL, data)
        .then((result) => {
          this.props.enqueueSnackbar("Bank Details Saved successfully", {
            variant: "success",
          });
          const { bankid } = result.data.result;
          const { subscriptionbankid } = result.data.result;
          this.setState({ bankid, subscriptionbankid, data: {} }, () => {
            this.props.onClose();
            this.props.GetAllBankDetails();
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  OnCancel() {
    this.setState({ data: {} }, () => {
      this.props.onClose();
    });
  }

  UpdateSelectedDropdownItem(name, HtField, value) {
    const selectedItem = { displayvalue: value, displayname: "" };
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    this.setState({ list });
    if (name == "banknameid") {
      list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ list, reqList, selectedbank: selectedItem });
    }
    if (name === "countryid") {
      Object.assign(this.state.list, { stateid: "" });
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState(
        {
          list,
          selectedState: "",
          reqList,
          selectedCountry: selectedItem,
        },
        () => {
          this.GetStateprovince();
        },
      );
    }
    if (name === "stateid") {
      this.setState({ list, selectedState: selectedItem });
    }
    if (name === "accounttype") {
      console.log("selectedItem: ", selectedItem);
      list[name] = selectedItem.displayvalue || "";
      reqList[name] = selectedItem.displayvalue || "";
      this.setState({ list, reqList, selectedAccount: selectedItem });
    }

    // if (reqList[name] == '' || reqList[name]) {
    //     reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : '';
    //     this.setState({ reqList }, () => {
    //         ValidateSearchDropdown(this.state, name).then(result => {
    //             this.setState({
    //                 ...result,
    //             })
    //         });
    //     });

    // }
    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      if (name != "accounttype") {
        reqList[name] = selectedItem.displayvalue
          ? selectedItem.displayvalue
          : "";
        this.setState({ reqList });
      }
      this.ValidateEachDropDown(name);
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  FormatChange(name, event) {
    this.setState({ [name]: event.target.checked }, () => {
      //        this.ValidateFormat()
    });
  }

  render() {
    const language = this.props.Language.configpayroll;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <DynamicForm
                  fields={selectinputconverter({
                    label: "Bank Name",
                    options: this.state.subscriptionBankList,
                    placeholder: "Select Bank",
                    value: get(this.state, "list.banknameid", ""),
                  })}
                  onChange={(val) =>
                    this.UpdateSelectedDropdownItem(
                      "banknameid",
                      "HtBankName",
                      val,
                    )
                  }
                />
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbBranchName"
                    defaultMessage="Branch Name"
                  />
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "branchname",
                    "HtBranchName",
                  )}
                  onChange={this.OnFieldChange.bind(this, "branchname", "name")}
                  onBlur={this.ValidateField.bind(this, "branchname", "name")}
                  value={this.state.fields.branchname}
                  maxLength="100"
                />
                <div>
                  {this.state.errors.branchname ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="Erbranchname"
                        defaultMessage="Please enter Branch Name"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="margin-top-10">
                <DynamicForm
                  fields={selectinputconverter({
                    label: "Account Type",
                    options: getOptArr({
                      arr: this.state.accountTypeList,
                      displaynamekey: "codename",
                      displayvaluekey: "codeid",
                    }),
                    placeholder: "Select Account Type",
                    value: get(this.state, "list.accounttype", ""),
                  })}
                  onChange={(val) =>
                    this.UpdateSelectedDropdownItem(
                      "accounttype",
                      "HtAccountType",
                      val,
                    )
                  }
                />
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbAccountNumber"
                    defaultMessage="Account Number"
                  />
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "accountnumber",
                    "HtAccountNumber",
                  )}
                  onBlur={this.ValidateField.bind(this, "accountnumber", "")}
                  onChange={this.OnFieldChange.bind(this, "accountnumber", "")}
                  value={this.state.fields.accountnumber}
                  maxLength="40"
                />
                <div>
                  {this.state.errors.accountnumber ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="Eraccountnumber"
                        defaultMessage="Please enter Account Number"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbAccountholderName"
                    defaultMessage="Accountholder Name"
                  />
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  value={this.state.fields.accountholdername}
                  onFocus={this.setHelperText.bind(
                    this,
                    "accountholdername",
                    "HtAccountholderName",
                  )}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "accountholdername",
                    "name",
                  )}
                  onBlur={this.ValidateField.bind(
                    this,
                    "accountholdername",
                    "name",
                  )}
                  maxLength="30"
                />
                <div>
                  {this.state.errors.accountholdername ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="Eraccountholdername"
                        defaultMessage="Please enter Account Holder Name"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbMICRCode"
                    defaultMessage="MICR Code"
                  />
                  &nbsp;
                  <FormattedMessage
                    id="LbOptional"
                    defaultMessage="(Optional)"
                  />
                </p>
                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "micrcode",
                    "HtMICRCode",
                  )}
                  onChange={this.OnFieldChange.bind(this, "micrcode", "text")}
                  value={this.state.fields.micrcode}
                  maxLength="40"
                />
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbIFSCCode"
                    defaultMessage="IFSC Code"
                  />
                  &nbsp;
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "ifsccode",
                    "HtIFSCCode",
                  )}
                  onChange={this.OnFieldChange.bind(this, "ifsccode", "name")}
                  onBlur={this.ValidateField.bind(this, "ifsccode", "name")}
                  value={this.state.fields.ifsccode}
                  maxLength="40"
                />
                <div>
                  {this.state.errors.ifsccode ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="Erifsccode"
                        defaultMessage="Please enter IFSC Code"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbSwiftCode"
                    defaultMessage="Swift Code"
                  />
                  &nbsp;
                  <FormattedMessage
                    id="LbOptional"
                    defaultMessage="(Optional)"
                  />
                </p>
                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "swiftcode",
                    "HtSwiftCode",
                  )}
                  onChange={this.OnFieldChange.bind(this, "swiftcode", "")}
                  value={this.state.fields.swiftcode}
                  maxLength="40"
                />
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbAddressLine1"
                    defaultMessage="Address Line1"
                  />
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "addressline1",
                    "HtAddressLine1",
                  )}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "addressline1",
                    "name",
                  )}
                  value={this.state.fields.addressline1}
                  maxLength="100"
                />
              </div>
              <div className="margin-top-10 padding-bottom-0">
                <p className="input-label">
                  <FormattedMessage
                    id="LbAddressLine2"
                    defaultMessage="Address Line2"
                  />
                  &nbsp;{" "}
                  <FormattedMessage
                    id="LbOptional"
                    defaultMessage="(Optional)"
                  />
                </p>

                <TextField
                  className="width100"
                  margin="dense"
                  variant="outlined"
                  onFocus={this.setHelperText.bind(
                    this,
                    "addressline2",
                    "HtAddressLine2",
                  )}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "addressline2",
                    "name",
                  )}
                  value={this.state.fields.addressline2}
                  maxLength="100"
                />
              </div>
              <div className="margin-top-10">
                <DynamicForm
                  fields={selectinputconverter({
                    options: this.state.country,
                    label: "Bank Branch Country",
                    placeholder: "Select Country",
                    value: get(this.state, "list.countryid", ""),
                  })}
                  onChange={(val) =>
                    this.UpdateSelectedDropdownItem(
                      "countryid",
                      "HtCountry",
                      val,
                    )
                  }
                />
              </div>
              <div className="margin-top-10">
                <DynamicForm
                  fields={selectinputconverter({
                    options: this.state.stateprovince,
                    label: "State/Province",
                    placeholder: "Select State",
                    value: get(this.state, "list.stateid", ""),
                  })}
                  onChange={(val) =>
                    this.UpdateSelectedDropdownItem(
                      "stateid",
                      "HtState/Province",
                      val,
                    )
                  }
                />
              </div>

              <div className="margin-top-10">
                <p className="add-label-active t-14">
                  <FormattedMessage
                    id="LbLinkBankAccountTo"
                    defaultMessage="Link Bank Account To"
                  />{" "}
                  <FormattedMessage
                    id="LbOptional"
                    defaultMessage="(Optional)"
                  />
                </p>
                <div>
                  <div
                    className={
                      this.state.ispayrolllinked === true
                        ? "depedent-select-list select-list-item"
                        : "depedent-select-list"
                    }
                    onClick={() => this.SetPayrolllink()}
                  >
                    <span>
                      <FormattedMessage
                        id="LbPayroll"
                        defaultMessage="Payroll"
                      />
                    </span>
                    {this.state.ispayrolllinked == true ? (
                      <span className="floatright selected-box">
                        {/* <img src={CheckImg} height="20" /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box "></span>
                    )}
                  </div>
                  <div
                    className={
                      this.state.isexpenselinked === true
                        ? "depedent-select-list select-list-item"
                        : "depedent-select-list"
                    }
                    onClick={() => this.SetExpenseslink()}
                  >
                    <span>
                      <FormattedMessage
                        id="LbExpenses"
                        defaultMessage="Expenses"
                      />
                    </span>
                    {this.state.isexpenselinked == true ? (
                      <span className="floatright selected-box">
                        {/* <img src={CheckImg} height="20" /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box "></span>
                    )}
                  </div>
                </div>
              </div>
              <div className="margin-top-10">
                <Button
                  className="btn btn-primary-sm-blue margin-right-8"
                  onClick={this.OnFormSubmit.bind(this)}
                >
                  Save
                </Button>
                <Button
                  className="btn btn-secondary-sm-blue"
                  onClick={this.OnCancel.bind(this)}
                >
                  Cancel
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(AddBankDetails)));

// export default withStyles(styles)(withSnackbar(AddBankDetails));
